import type { JSX } from "react";

import moreIcon from "@impero-com/common/img/more.svg";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";

import * as styles from "./TileActionMenu.css";

export function TileActionMenu({
    items,
}: {
    items: MenuProps["items"];
}): JSX.Element {
    return (
        <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
            <button
                type="button"
                aria-label="Actions"
                className={styles.moreButton}
            >
                <img src={moreIcon} alt="" width={18} height={18} />
            </button>
        </Dropdown>
    );
}
